import { render } from "./OrderDetails.vue?vue&type=template&id=afdc3c4c&scoped=true&ts=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=afdc3c4c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdc3c4c"]])

export default __exports__